import WizardBase from "./wizardBase";
import WizardProgress from "./wizardProgress";
import WizardSimpleStep from "./wizardSimpleStep";
import WizardStep from "./wizardStep";

export type {
  WizardBaseProps as WizardProps,
  WizardSimpleStepProps,
  WizardStepProps,
  WizardStepStatus,
} from "./types";

const Wizard = Object.assign(WizardBase, {
  Progress: WizardProgress,
  Step: WizardStep,
  SimpleStep: WizardSimpleStep,
});

export default Wizard;
